/* Three stages of recovery page: moon panel on scroll, body maps, uterus slider, timeline. */
(function () {
  var root = document.querySelector('.gm-ts');
  if (!root) return;

  // Let the hero run up behind the breadcrumb bar, whatever its height
  var bc = document.querySelector('#MainContent > [id$="__breadcrumbs"]');
  var fitBc = function () { if (bc) root.style.setProperty('--gm-bc-h', bc.offsetHeight + 'px'); };
  fitBc(); window.addEventListener('resize', fitBc);

  // Waxing moon: f = lit fraction 0..1, lit from the right
  function moonPath(f, cx, cy, r) {
    f = Math.max(0.02, Math.min(1, f));
    if (f >= 0.999) return 'M' + cx + ' ' + (cy - r) + 'A' + r + ' ' + r + ' 0 1 1 ' + cx + ' ' + (cy + r) + 'A' + r + ' ' + r + ' 0 1 1 ' + cx + ' ' + (cy - r) + 'Z';
    var rx = r * Math.abs(1 - 2 * f), sweep = f < 0.5 ? 0 : 1;
    return 'M' + cx + ' ' + (cy - r) + 'A' + r + ' ' + r + ' 0 0 1 ' + cx + ' ' + (cy + r) + 'A' + rx.toFixed(2) + ' ' + r + ' 0 0 ' + sweep + ' ' + cx + ' ' + (cy - r) + 'Z';
  }

  // Moon panel: day 1 to 30 follows the reader through the three stages
  var rail = root.querySelector('.rail'), stages = [].slice.call(root.querySelectorAll('.stage'));
  if (rail && stages.length === 3) {
    var railMoon = rail.querySelector('.rail-moon'), railDay = rail.querySelector('.rail-day'), railStage = rail.querySelector('.stage-name');
    var bars = [].slice.call(rail.querySelectorAll('.bar b')), names = JSON.parse(rail.dataset.names || '[]'), lastDay = 0;
    // Page background takes each stage's colour, deepening from the stage's first day to its last
    var journey = root.querySelector('.journey'), GROUND = [255, 250, 245];
    var TINT = [[169, 94, 125], [118, 96, 146], [88, 121, 105]];
    var mix = function (a, b, t) { return a.map(function (v, i) { return Math.round(v + (b[i] - v) * t); }); };
    var paint = function (pos) {
      if (!journey) return;
      if (pos <= 0) { journey.style.setProperty('--journey-bg', 'rgb(' + GROUND + ')'); return; }
      // Within each stage: lightest on its first day, deepest on its last (day 10, 20, 30)
      var i = Math.min(2, Math.floor(pos)), f = Math.min(1, pos - i), LIGHT = 0.04, DEEP = 0.24;
      var col = mix(GROUND, TINT[i], LIGHT + (DEEP - LIGHT) * f);
      journey.style.setProperty('--journey-bg', 'rgb(' + col + ')');
    };
    var update = function () {
      // Line up with the moon panel: its top on desktop, the bottom of the slim bar on phones
      // ...and reach the stage's last day when its bottom meets the panel's bottom (screen bottom on phones)
      var rr = rail.getBoundingClientRect(), phone = window.innerWidth <= 900;
      var mid = (phone ? rr.bottom : rr.top) + 2, end = phone ? window.innerHeight : rr.bottom, day = 1, pos = 0;
      stages.forEach(function (st, i) {
        var r = st.getBoundingClientRect();
        var p = Math.max(0, Math.min(1, (mid - r.top) / Math.max(1, r.height - (end - mid))));
        bars[i].style.transform = 'scaleX(' + p + ')';
        if (r.top <= mid) { day = Math.max(day, Math.min(30, i * 10 + 1 + Math.min(9, Math.floor(p * 10)))); pos = Math.max(pos, i + Math.min(p, 0.999)); }
      });
      paint(stages[0].getBoundingClientRect().top <= mid ? Math.max(pos, 0.01) : 0);
      if (day === lastDay) return;
      lastDay = day;
      var s = day <= 10 ? 0 : day <= 20 ? 1 : 2;
      railMoon.setAttribute('d', moonPath(day / 30, 50, 50, 44));
      railDay.textContent = day;
      railStage.textContent = names[s] || '';
      rail.dataset.stage = String(s + 1);
    };
    var ticking = false;
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // Body maps: tap a point or a label; panels share one cell so nothing jumps
  root.querySelectorAll('.bodymap').forEach(function (bm) {
    bm.addEventListener('click', function (e) {
      var b = e.target.closest('.hs, .chip'); if (!b) return;
      var i = b.dataset.i;
      bm.querySelectorAll('.hs, .chip').forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.i === i)); });
      bm.querySelectorAll('.bm-panel').forEach(function (p) { var off = p.dataset.i !== i; p.classList.toggle('off', off); p.setAttribute('aria-hidden', String(off)); });
    });
  });

  // Timeline: tap a bar to read about it
  var tlRows = [].slice.call(root.querySelectorAll('.tl-row')), tlDetail = root.querySelector('.tl-detail');
  tlRows.forEach(function (r) {
    r.addEventListener('click', function () {
      tlRows.forEach(function (x) { x.setAttribute('aria-pressed', String(x === r)); });
      tlDetail.textContent = r.dataset.detail;
    });
  });

  // Gentle reveal (content stays readable before it runs)
  var rv = root.querySelectorAll('.rv');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (el) { io.observe(el); });
  } else {
    rv.forEach(function (el) { el.classList.add('in'); });
  }
})();
